import React, { createContext, useContext, useState, useEffect } from 'react';

const PDFAuthContext = createContext();

const AUTH_KEY = 'pdf_auth_status';
const AUTH_TS_KEY = 'pdf_auth_timestamp';
const AUTH_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export const usePDFAuth = () => {
  const context = useContext(PDFAuthContext);
  if (!context) {
    throw new Error('usePDFAuth must be used within a PDFAuthProvider');
  }
  return context;
};

export const PDFAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const status = localStorage.getItem(AUTH_KEY);
    const ts = parseInt(localStorage.getItem(AUTH_TS_KEY) || '0', 10);
    const isValid = status === 'authenticated' && Date.now() - ts < AUTH_TTL_MS;

    if (isValid) {
      setIsAuthenticated(true);
    } else {
      // Clear any stale/expired auth
      localStorage.removeItem(AUTH_KEY);
      localStorage.removeItem(AUTH_TS_KEY);
    }
  }, []);

  const authenticate = () => {
    setIsAuthenticated(true);
    localStorage.setItem(AUTH_KEY, 'authenticated');
    localStorage.setItem(AUTH_TS_KEY, Date.now().toString());
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(AUTH_TS_KEY);
  };

  return (
    <PDFAuthContext.Provider value={{ isAuthenticated, authenticate, logout }}>
      {children}
    </PDFAuthContext.Provider>
  );
};
